<div class="verify-outer-bg-section">
    <div id="menuOverlay" (click)="closeNav()"></div>
    <div id="mySidenav" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
    <div class="logo-div sidemenu-logo-div" routerLink="/">
        <img src="assets/images/pups-logo-header.svg" alt="">
    </div>


    




    

    
    
    <li><a routerLink="/contact-us">{{'Contact' | translate}}</a></li>


    <li  class="">
        <!-- <a class="register-button" data-toggle="modal" data-target="#signupModal" (click)="closeNav()">{{'Register' | translate}}</a> -->
        <a class="register-button" routerLink="/" (click)="closeNav()">{{'Home' | translate}}</a>
    </li>
    
    <div class="language-container">
        <form [formGroup]="languageForm">

        <div class="toggle-button-cover">
            <div class="button-cover">
            <div class="button r" id="button-6">
                <input type="checkbox" class="checkbox" (change)="getChangelang($event)" />
                <div class="knobs"></div>
                <div class="layer"></div>
            </div>
            </div>
        </div>
        </form>
    </div>
    </div>

    <header class="header-home-page verify-header">
    <div class="header-section verify-header">
        <div class="display-flex-head">
            <div class="button_container" (click)="openNav()">
                <div><span class="top"></span><span class="middle"></span><span class="bottom">
                </span></div>
            </div>
            <div class="logo-div">
                <img src="assets/images/pups-logo-header.svg" alt="">
            </div>

            
            <div class="flex-right-section mobile-side-menu-display">
                <div class="ul-section mobile-side-menu-display" >
                    <ul class="ul-list">
                        <li> <a routerLink="/" >{{'Home' | translate}}</a> </li>
                    </ul>
                </div>

                <div class="language-toggle-section">
                    <div class="dropdown">
                        <div class="toggle-button-cover">
                            <div class="button-cover">
                                <div class="button home-page-toggle-btn r" id="button-6">
                                    <input type="checkbox" class="checkbox" (change)="getChangelang($event)" />
                                    <div class="knobs"></div>
                                    <div class="layer verify-page"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </header>

    <div class="verify-outer-bg-div">
        <!-- <div class="verify-image-div">
            <img src="assets/images/sync-image-Charac.png" class=" img-fluid">
        </div> -->
        
        <div class="verify-inner-box-div modal-lg" *ngIf="isVerifyAsSection" [ngClass]="{'modal-lg': isEmployerDetailsSection || isEmployeeDetailSection}">
            <!-- <h2 class="verify-title">{{'Verification of Employer' | translate}}</h2>
            <p class="para-light">{{'Please provide the following information to verify your employer.' | translate}}</p> -->


            <div  class="text-center" >
                <!-- <h5 class="title-medium">{{'Verify As' | translate}}</h5>

                <div class="button-container">
                <button type="button" class="btn btn-main"  >{{'Employee' | translate}}</button>
                <h6>{{'or' | translate}}</h6>
                <button type="button" class="btn btn-main"  >{{'Employer' | translate}}</button>
                </div> -->
                    <!-- <button class="back-btn-verify position-unset-mobile" ><img src="assets/images/back-arrow.png"
                            alt=""></button> -->

                <div class="verify-image-div">
                    <img src="assets/images/sync-image-Charac.png" class=" img-fluid">
                </div>

                <div class="head-section-verify">
                    <!-- <h5 class="verify-title mb-4">{{'Company and employee verification' | translate}}</h5> -->
                    <h5 class="verify-title mb-4">{{'Company verification' | translate}}</h5>
                    <!-- <p class="para-light text-center">{{'Verify company and employee details by providing the required identification information. The system will automatically retrieve and validate data from official public databases.' | translate}}</p> -->
                </div>

                <div class="verify-card-section">
                    <div class="verify-card">
                        <div class="logo-img">
                            <img src="assets/images/employer-img.png" alt="">

                            <h2 class="img-title">{{'Employer' | translate}}</h2>
                        </div>
                        <div class="btn-div">
                            <button class="employee-btn-verify" (click)="onVerifyAs('employer')">{{'Verify as Employer' | translate}}</button>
                        </div>
                    </div>

                    <!-- <div class="verify-card">
                        <div class="logo-img">
                            <img src="assets/images/employee-img.png" alt="">

                            <h2 class="img-title">{{'Employee' | translate}}</h2>
                        </div>
                        <div class="btn-div">
                            <button class="employee-btn-verify" (click)="onVerifyAs('employee')" >{{'Verify as Employee' | translate}}</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="verify-inner-box-div modal-lg" *ngIf="isNIFSection">

            <div class="nif-number-input-section" >
                <div class="display-flex-head-mobile mb-3">
                    <button class="back-btn-verify position-unset-mobile" (click)="onBack('nif')"><img src="assets/images/back-arrow.png" alt=""></button>
                    <h2 class="verify-title ">{{'Verification of Employer' | translate}}</h2>
                </div>
                <!-- <p class="para-light text-center">{{'Kindly provide your Tax Identification Number (NIF) to allow the system to automatically fetch your company’s information from official public databases (DGI, CNSS, CNAMGS).' | translate}}</p> -->
                <form [formGroup]="verifyNIFForm">
                    <div class="input-div mb-4">
                        <div class="input-box-white">
                            <p class="labeltxt text-center">{{'N NIF' | translate}}</p>
                            <input type="text" name="nif_number" formControlName="nif_number" maxlength="100" placeholder="{{'Enter NIF number' | translate}}">
                            <p class="note-small-text text-danger">* {{'Please enter the NIF without spaces.' | translate}}</p>
                        </div>

                        <div *ngIf="isSubmittedNIF && g.nif_number.errors" class="invalid-feedback">
                            <div *ngIf="g.nif_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                            <div *ngIf="g.nif_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                        </div>
                    </div>

                    <div class="input-div">
                        <div class="input-box-white">
                            <p class="labeltxt text-center">{{'Email' | translate}}</p>
                            <input type="text" name="email" formControlName="email" maxlength="100" placeholder="{{'Enter your email' | translate}}">
                            <p class="note-small-text text-danger">* {{'Please enter valid email address. The OTP will be sent to this email.' | translate}}</p>
                        </div>

                        <div *ngIf="isSubmittedNIF && g.email.errors" class="invalid-feedback">
                            <div *ngIf="g.email.errors?.required">{{'This field is mandatory'|translate}}</div>
                            <div *ngIf="g.email.errors?.email">{{'This field should be valid'|translate}}</div>
                        </div>
                    </div>


                    <div class="nif-btn-submit-div text-center">
                        <button class="btn btn-medium" (click)="onSubmitVerifyNIF()">{{'Next'|translate}}</button>
                    </div>

                    <!-- <div class="nif-btn-submit-div text-center">
                        <button class="btn btn-medium" (click)="onSubmitVerifyNIF('without-cnns&cnamgs-value')">{{'Next'|translate}}</button>
                    </div> -->

                    <!-- <div class="nif-btn-submit-div text-center">
                        <button class="btn btn-medium" (click)="onSubmitVerifyNIF('Resubmit')">{{'Resubmit'|translate}}</button>
                    </div>

                    <div class="nif-btn-submit-div text-center">
                        <button class="btn btn-medium" (click)="onSubmitVerifyNIF('Resubmit-cnns&cnamgs')">{{'Resubmit-cnns&cnamgs'|translate}}</button>
                    </div> -->

                    

                </form>
            </div>
        </div>

    <div class="verify-inner-box-div group-verify-bg" *ngIf="isCNSSSection || isCNSSSectionValue || isCnamgsSection || isCnamgsSectionValue || isEmployerDetailsSection">


        <button class="back-btn-verify" (click)="onBack('resubmit')"><img src="assets/images/back-arrow.png" alt=""></button>

        <div class="head-section-verify mb-3">
            <h5 class="company-title ">{{companyName || '--' | translate}}</h5>
        <p class="label-txt">{{'N NIF' | translate}} : <span>{{companyNif || '--' | translate}}</span></p>
        </div>


        <div class="rejected-reason-section" *ngIf="isRejected" >
            <h5>{{"Reason for rejection" | translate}}</h5>
            <p class="reason bold">{{"Rejected by" | translate}} : <span> {{rejectedBy | translate}}</span></p>
            <p class="reason bold" *ngIf="employerDetailsResponse.result.cnss_rejected_date">{{"CNSS Rejected on" | translate}} : <span> {{employerDetailsResponse.result.cnss_rejected_date | translate}}</span></p>
            <p class="reason bold" *ngIf="employerDetailsResponse.result.cnamgs_rejected_date">{{"CNAMGS Rejected on" | translate}} : <span> {{employerDetailsResponse.result.cnamgs_rejected_date | translate}}</span></p>
            <p class="reason bold" *ngIf="employerDetailsResponse.result.cnss_rejected_reason"> {{'CNSS Reason' | translate}} : <span> {{employerDetailsResponse.result.cnss_rejected_reason | translate}}</span></p>
            <p class="reason bold" *ngIf="employerDetailsResponse.result.cnamgs_rejected_reason"> {{'CNAMGS Reason' | translate}} : <span> {{employerDetailsResponse.result.cnamgs_rejected_reason | translate}}</span></p>
        
        </div>

        <div class="display-flex-center-div" *ngIf="isCNSSSectionValue || isCnamgsSectionValue">
            <div class="verify-inner-box-div " *ngIf="isCNSSSectionValue">
                <div class="head-section-verify">
                    <h5 class="verify-title mb-2 text-center">{{'CNSS Number Details' | translate}}</h5>
                    <p class="para-light text-center">{{'The CNSS number shown below has been automatically retrieved from official records for verification.' | translate}}</p>
                </div>
            
                <div class="display-flex-head-mobile">
                    <!-- <button *ngIf="!isResubmit" class="back-btn-verify" (click)="onBack('cnss')"><img src="assets/images/back-arrow.png" alt=""></button> -->
                    <div class="label-img-div"><img src="assets/images/CNSS-logo-col.png" alt="" class="img-fluid"> </div> 
                </div>
            
                <div class="cnss-number-display-section">
                    <p class="cnns-display-text">{{'N CNSS' | translate}} : <span>{{cnssSectionValue || '--'}}</span></p>
                </div>
            
                <!-- <div class="nif-btn-submit-div text-center mt-3">
                    <button class="btn btn-medium" (click)="onSubmitVerifyCNSSValue()">{{'Next'|translate}}</button>
                </div> -->
            
            </div>
            
            <div class="verify-inner-box-div " *ngIf="isCnamgsSectionValue">
                <div class="head-section-verify">
                    <h5 class="verify-title mb-2 text-center">{{'CNAMGS Number Details' | translate}}</h5>
                    <p class="para-light text-center">{{'The CNAMGS number shown below has been automatically retrieved from official records for verification.' | translate}}</p>
                </div>
            
                <div class="display-flex-head-mobile">
                    <!-- <button *ngIf="!isResubmit" class="back-btn-verify" (click)="onBack('cnss')"><img src="assets/images/back-arrow.png" alt=""></button> -->
                    <div class="label-img-div"><img src="assets/images/cnamgslogo.png" alt="" class="img-fluid"> </div> 
                </div>
            
                <div class="cnss-number-display-section">
                    <p class="cnns-display-text">{{'N CNAMGS' | translate}} : <span>{{cnamgsSectionValue || '--'}}</span></p>
                </div>
            
                <!-- <div class="nif-btn-submit-div text-center mt-3">
                    <button class="btn btn-medium" (click)="onSubmitVerifyCnamgsValue()">{{'Next'|translate}}</button>
                </div> -->
            
            </div>
        </div>

        <div class="display-flex-center-div" *ngIf="isCNSSSection || isCnamgsSection">
            <div class="verify-inner-box-div " *ngIf="isCNSSSection">
                <div class="cnss-yes-no-section" >
                    <div class="head-section-verify">
                        <h5 class="verify-title mb-2">{{'CNSS verification' | translate}}</h5>
                        <p class="para-light text-center"><span class="red">{{'The system could not retrieve any CNSS information linked to the provided NIF.' | translate}}</span> <br>{{'If you are already registered with CNSS, please provide the following details to verify your CNSS number.' | translate}}</p>
                    </div>
                    <div class="display-flex-head-mobile">
                        <!-- <button *ngIf="!isResubmit" class="back-btn-verify" (click)="onBack('cnss')"><img src="assets/images/back-arrow.png" alt=""></button> -->
                        <div class="label-img-div"><img src="assets/images/CNSS-logo-col.png" alt="" class="img-fluid"> </div> 
                    </div> 
                    <div class="radio-box-section">
                        <form  [formGroup]="verifyCNSSForm">
                            <div class="radio-box-container">
                                <p class="radio-box-title">{{'Are you registered to CNSS ?' | translate}}</p>
                                <div class="checkbox-group">
                                    <mat-radio-group formControlName="is_reg_cnss" class="mat-radio-btn">
                                        <mat-radio-button [value]="1">{{ 'Yes' | translate }}</mat-radio-button>
                                        <mat-radio-button [value]="0">{{ 'No' | translate }}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
            
                                <div class="input-div mt-1" *ngIf="isRegCnssValue === 1">
                                    <div class="input-box-white">
                                        <p class="labeltxt text-center">{{'N CNSS' | translate}} <span class="mandatory" >*</span> <span *ngIf="CNSSVerifyStatus" class="ml-1"><i class="fa fa-check-circle"></i></span></p>
                                        <input type="text" name="cnss_number" formControlName="cnss_number" maxlength="100" placeholder="{{'Enter CNSS number' | translate}}">
                                        <p class="note-small-text">{{'Note: Please enter the CNSS without spaces.' | translate}}</p>
                                        <div class="text-center mt-2">
                                            <button type="button" class="btn btn-sm" (click)="onValidateCnssNumber()" [disabled]="verifyCNSSForm.get('cnss_number')?.invalid">
                                                {{'Validate' | translate}}
                                            </button>
                                        </div>
                                    </div>

                                    <!-- <p *ngIf="cnssValidateAttempted && !CNSSVerifyStatus" class="note-small-text text-center mt-1">
                                        {{'Your CNSS number is not verified but you can proceed forward.' | translate}}
                                    </p> -->
                                    <p *ngIf="cnssValidateAttempted && !CNSSVerifyStatus" class="para-light text-center mt-1"><span class="red">{{'Your CNSS number is not verified but you can proceed forward.' | translate}}</span></p>

                                    <div *ngIf="cnssSubmitAttempted && isCNSSSection && isRegCnssValue === 1 && !cnssValidateAttempted" class="invalid-feedback text-center d-block mt-1">
                                        {{'Please validate CNSS number to proceed.' | translate}}
                                    </div>

                                    
                
                                    <div *ngIf="isSubmittedCnss && gCNSS.cnss_number.errors" class="invalid-feedback">
                                        <div *ngIf="gCNSS.cnss_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                                        <div *ngIf="gCNSS.cnss_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                                    </div>
                                </div>
            
                                <!-- <div class="nif-btn-submit-div text-center mt-2">
                                    <button class="btn btn-medium" (click)="onSubmitVerifyCNSS()">{{'Next'|translate}}</button>
                                </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            
            
            <div class="verify-inner-box-div " *ngIf="isCnamgsSection">
            
                <div class="cnss-yes-no-section" >
                    <div class="head-section-verify">
                        <h5 class="verify-title mb-2">{{'CNAMGS verification' | translate}}</h5>
                        <p class="para-light text-center"><span class="red">{{'The system could not retrieve any CNAMGS information linked to the provided NIF.' | translate}}</span> <br>{{'If you are already registered with CNAMGS, please provide the following details to verify your CNAMGS number.' | translate}}</p>
                    </div>
                    <div class="display-flex-head-mobile">
                        <!-- <button *ngIf="!isResubmit" class="back-btn-verify" (click)="onBack('cnamgs')"><img src="assets/images/back-arrow.png" alt=""></button> -->
                        <div class="label-img-div"><img src="assets/images/cnamgslogo.png" alt="" class="img-fluid"> </div>
                    </div>  
                    <div class="radio-box-section">
                        <form  [formGroup]="verifyCnamgsForm">
                            <div class="radio-box-container">
                                <p class="radio-box-title">{{'Are you registered to CNAMGS ?' | translate}}</p>
                                <div class="checkbox-group">
                                    <mat-radio-group formControlName="is_reg_cnamgs" class="mat-radio-btn">
                                        <mat-radio-button [value]="1">{{ 'Yes' | translate }}</mat-radio-button>
                                        <mat-radio-button [value]="0">{{ 'No' | translate }}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
            
                                <div class="input-div mt-1" *ngIf="isRegCnamgsValue === 1">
                                    <div class="input-box-white">
                                        <p class="labeltxt text-center">{{'N CNAMGS' | translate}} <span class="mandatory" >*</span></p>
                                        <input type="text" name="cnamgs_number" formControlName="cnamgs_number" maxlength="100" placeholder="{{'Enter CNAMGS number' | translate}}">
                                        <p class="note-small-text">{{'Note: Please enter the CNAMGS without spaces.' | translate}}</p>
                                    </div>
                
                                    <div *ngIf="isSubmittedCnamgs && gCnamgs.cnamgs_number.errors" class="invalid-feedback">
                                        <div *ngIf="gCnamgs.cnamgs_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                                        <div *ngIf="gCnamgs.cnamgs_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                                    </div>
                                </div>
            
                                <!-- <div class="nif-btn-submit-div text-center mt-2">
                                    <button class="btn btn-medium" (click)="onSubmitVerifyCnamgs()">{{'Next'|translate}}</button>
                                </div> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="verify-inner-box-div fc-common-div" *ngIf="showCommonFc">
            <form [formGroup]="verifyCompanyForm">
                <div class="input-div mt-1" *ngIf="legalNatureStatus">
                    <p class="note-small-text text-center mb-2">
                        {{'DGI owner name note' | translate}}
                        <span class="ml-1">({{companyName || '--'}})</span>
                    </p>
                    <div class="input-box-white">
                        <p class="labeltxt text-center">{{'Company name' | translate}} <span class="mandatory" >*</span></p>
                        <input type="text" name="company_name" formControlName="company_name_entered" maxlength="100" placeholder="{{'Enter Company name' | translate}}">
                    </div>

                    <div *ngIf="(isSubmittedCnss || isSubmittedCnamgs) && gCompany.company_name_entered?.errors" class="invalid-feedback">
                        <div *ngIf="gCompany.company_name_entered.errors?.required">{{'This field is mandatory'|translate}}</div>
                    </div>
                </div>

                <div class="upload-div">
                    <div class="input-div ">
                        <label for="companyFc" class="labeltxt">{{'Kindly upload the FC' | translate}} <span class="mandatory" >*</span> <span *ngIf="companyFc" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                        <label for="companyFc" class="file-upload-card labeltxt">
                            <div class="custom-container UploadIcon">
                                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                                <input class="uploadOrdrop" id="companyFc" type="file" formControlName="company_fc" accept=".jpg,.jpeg,.png,.pdf,.heic,.heif" (change)="upload($event, 'company_fc')" data-target="company_fc" hidden>
                                <i class="fa fa-upload " aria-hidden="true"></i>
                            </div>
                        </label>
                        <div class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                        <a *ngIf="companyFcURL" href="{{companyFcURL}}" target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
                        <div *ngIf="(isSubmittedCnss || isSubmittedCnamgs) && gCompany.company_fc?.errors" class="invalid-feedback text-center m-0">
                            <div *ngIf="gCompany.company_fc.errors?.fileType">{{'File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .heic .heif'|translate}}</div>
                            <div *ngIf="gCompany.company_fc.errors?.size">{{'File Size should not be grater than 10 MB.'|translate}}</div>
                            <div *ngIf="gCompany.company_fc.errors?.required">{{'This field is mandatory'|translate}}</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        
        
        <div class="verify-inner-box-div  text-input-left" *ngIf="shouldShowManagerForm && isEmployerDetailsSection">
            <div class="employer-manager-details-section " >
                <div class="display-flex-head-mobile mb-3">
                    <!-- <button *ngIf="!isResubmit" class="back-btn-verify position-unset-mobile" (click)="onBack('employer-manager')"><img src="assets/images/back-arrow.png" alt=""></button> -->
                    <h2 class="text-center mb-0">{{'Employer details' | translate}}</h2>
                </div>
        
                <form [formGroup]="verifyManagerForm">
        
                    <div class="sub-section-with-line mb-3">
                        <div class="container mt-5">
                        <h6 class="">{{'Manager details' | translate}}<span class="mandatory" >*</span></h6>
                        </div>
                        <div class="line"></div>
                    </div>
        
                    <div class="form-grid-group">
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'First name of manager' | translate}}<span class="mandatory" >*</span></p>
                                <input type="text" name="first_name" formControlName="first_name" maxlength="100" placeholder="{{'Enter First name of manager' | translate}}">
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.first_name.errors" class="invalid-feedback">
                                <div *ngIf="gManager.first_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.first_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Last name of manager' | translate}}<span class="mandatory" >*</span></p>
                                <input type="text" name="last_name" formControlName="last_name" maxlength="100" placeholder="{{'Enter Last name of manager' | translate}}">
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.last_name.errors" class="invalid-feedback">
                                <div *ngIf="gManager.last_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.last_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Email of manager' | translate}}<span class="mandatory" >*</span></p>
                                <input type="text" name="email" formControlName="email" maxlength="100" placeholder="{{'Enter Email of manager' | translate}}">
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.email.errors" class="invalid-feedback">
                                <div *ngIf="gManager.email.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.email.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Phone number of manager' | translate}}<span class="mandatory" >*</span></p>
                                <input type="text" name="phone_number" formControlName="phone_number" minlength="8" maxlength="8" placeholder="{{'Enter Phone number of manager' | translate}}">
                                    <p class="note-small-text">Note : {{'Mobile should start with valid numbers like 77, 76, 74, 66, 65, 62, 60, 61'|translate}}</p>
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.phone_number.errors" class="invalid-feedback">
                                <div *ngIf="gManager.phone_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.phone_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                    </div>
        
                    <div class="upload-div">
                        <div class="input-div ">
                            <label for="managerIdProof" class="labeltxt">{{'Upload ID proof of manager' | translate}}<span class="mandatory" *ngIf="!managerIdProof">*</span> <span *ngIf="managerIdProof" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                            <label for="managerIdProof" class="file-upload-card labeltxt">
                                <div class="custom-container UploadIcon">
                                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                                    <input class="uploadOrdrop" id="managerIdProof" type="file" formControlName="managerIdProof" accept=".jpg,.jpeg,.png,.pdf,.heic,.heif" (change)="upload($event, 'managerIdProof')" data-target="managerIdProof" hidden>
                                    <i class="fa fa-upload " aria-hidden="true"></i>
                                    <!-- <i class="fa-solid fa-upload" aria-hidden="true"></i> -->
                                </div>
                            </label>
                            <div class="text-sm textUnderMobile ">* {{'File Size and file format'|translate}}</div>
                            <a *ngIf="managerIdProofURL" id="managerIdProof" href="{{managerIdProofURL}}" target="_blank" class="viewFile text-center">{{'Click to view File'|translate}}</a>
                            <div *ngIf="isSubmittedManager && gManager.managerIdProof.errors" class="invalid-feedback text-center m-0">
                            <div *ngIf="gManager.managerIdProof.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}
                            </div>
                            <div *ngIf="gManager.managerIdProof.errors.required">{{'This field is mandatory'|translate}}</div>
                            </div>
                        </div>
                    </div>
        
                    <div class="sub-section-with-line mb-3">
                        <div class="container mt-5">
                            <h6 class="">{{'Agency manager details' | translate}}</h6>
                        </div>
                        <div class="line"></div>
                    </div>
        
                    <div class="form-grid-group">
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'First name of agent' | translate}}</p>
                                <input type="text" name="agent_first_name" formControlName="agent_first_name" maxlength="100" placeholder="{{'Enter First name of agent' | translate}}">
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.agent_first_name.errors" class="invalid-feedback">
                                <div *ngIf="gManager.agent_first_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.agent_first_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Last name of agent' | translate}}</p>
                                <input type="text" name="agent_last_name" formControlName="agent_last_name" maxlength="100" placeholder="{{'Enter Last name of agent' | translate}}">
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.agent_last_name.errors" class="invalid-feedback">
                                <div *ngIf="gManager.agent_last_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.agent_last_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Email of agent' | translate}}</p>
                                <input type="text" name="agent_email" formControlName="agent_email" maxlength="100" placeholder="{{'Enter Email of agent' | translate}}">
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.agent_email.errors" class="invalid-feedback">
                                <div *ngIf="gManager.agent_email.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.agent_email.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
        
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Phone number of agent' | translate}}</p>
                                <input type="text" name="agent_phone_number" formControlName="agent_phone_number" minlength="8" maxlength="8" placeholder="{{'Enter Phone number of agent' | translate}}">
                                    <p class="note-small-text">Note : {{'Mobile should start with valid numbers like 77, 76, 74, 66, 65, 62, 60, 61'|translate}}</p>
                            </div>
        
                            <div *ngIf="isSubmittedManager && gManager.agent_phone_number.errors" class="invalid-feedback">
                                <div *ngIf="gManager.agent_phone_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                                <div *ngIf="gManager.agent_phone_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                        </div>
                        <div class="upload-div">
                            <div class="input-div ">
                                <label for="agent_managerIdProof" class="labeltxt">{{'Upload ID proof of agent' | translate}} <span *ngIf="agent_managerIdProof" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                                <label for="agent_managerIdProof" class="file-upload-card labeltxt">
                                <div class="custom-container UploadIcon">
                                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                                    <input class="uploadOrdrop" id="agent_managerIdProof" type="file" formControlName="agent_managerIdProof" accept=".jpg,.jpeg,.png,.pdf,.heic,.heif" (change)="upload($event, 'agent_managerIdProof')" data-target="agent_managerIdProof" hidden>
                                    <i class="fa fa-upload " aria-hidden="true"></i>
                                </div>
                                </label>
                                <div class="text-sm textUnderMobile ">* {{'File Size and file format'| translate}}</div>
                                <a *ngIf="agent_managerIdProofURL" id="agent_managerIdProof" href="{{agent_managerIdProofURL}}" target="_blank" class="viewFile text-center">{{'Click to view File'| translate}}</a>
                                <div *ngIf="isSubmittedManager && gManager.agent_managerIdProof.errors" class="invalid-feedback text-center m-0">
                                <div *ngIf="gManager.agent_managerIdProof.errors.size">{{'File Size should not be grater than 10 MB.'| translate}}
                                </div>
                                <div *ngIf="gManager.agent_managerIdProof.errors.required">{{'This field is mandatory'|translate}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="upload-div">
                            <div class="input-div ">
                                <label for="agent_managerPowerOfattorney" class="labeltxt">{{'Power of attorney' | translate}} <span *ngIf="agent_managerPowerOfattorney" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                                <label for="agent_managerPowerOfattorney" class="file-upload-card labeltxt">
                                <div class="custom-container UploadIcon">
                                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                                    <input class="uploadOrdrop" id="agent_managerPowerOfattorney" type="file" formControlName="agent_managerPowerOfattorney" accept=".jpg,.jpeg,.png,.pdf,.heic,.heif" (change)="upload($event, 'agent_managerPowerOfattorney')" data-target="agent_managerPowerOfattorney" hidden>
                                    <i class="fa fa-upload " aria-hidden="true"></i>
                                </div>
                                </label>
                                <div class="text-sm textUnderMobile ">* {{'File Size and file format'| translate}}</div>
                                <a *ngIf="agent_managerPowerOfattorneyURL" id="agent_managerPowerOfattorney" href="{{agent_managerPowerOfattorneyURL}}" target="_blank" class="viewFile text-center">{{'Click to view File'| translate}}</a>
                                <div *ngIf="isSubmittedManager && gManager.agent_managerPowerOfattorney.errors" class="invalid-feedback text-center m-0">
                                <div *ngIf="gManager.agent_managerPowerOfattorney.errors.size">{{'File Size should not be grater than 10 MB.'| translate}}
                                </div>
                                <div *ngIf="gManager.agent_managerPowerOfattorney.errors.required">{{'This field is mandatory'|translate}}</div>
                                </div>
                            </div>
                        </div>
        
                    </div>
        
            
                </form>
            </div>
        </div>
        <div class="nif-btn-submit-div text-center ">
            <button class="btn btn-medium" (click)="onSubmitVerifyManager()">{{'Submit'|translate}}</button>
        </div>
    </div>

    

        <div class="verify-inner-box-div modal-lg" *ngIf="isEmployeeIDSection">

            <div class="employee-section-verify text-center" >
                <div class="display-flex-head-mobile mb-3">
                    <button class="back-btn-verify position-unset-mobile" (click)="onBack('employee')"><img src="assets/images/back-arrow.png" alt=""></button>
                    <h2 class="verify-title">{{'Verification of Employee' | translate}}</h2>
                </div>
                <form [formGroup]="verifyEmployeeForm">
                    <div class="input-div mb-4">
                        <div class="input-box-white">
                            <p class="labeltxt text-center">{{'NIP/CNSS/CNAMGS' | translate}}</p>
                            <input type="text" name="nip_number" formControlName="nip_number" maxlength="100" placeholder="{{'Enter NIP/CNSS/CNAMGS Number' | translate}}">
                            <p class="note-small-text text-danger">* {{'Please enter valid NIP/CNSS/CNAMGS number without spaces.' | translate}}</p>
                        </div>

                        <div *ngIf="isSubmittedEmployee && gEmployee.nip_number.errors" class="invalid-feedback">
                            <div *ngIf="gEmployee.nip_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                            <div *ngIf="gEmployee.nip_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                        </div>
                    </div>

                    <div class="input-div">
                        <div class="input-box-white">
                            <p class="labeltxt text-center">{{'Email' | translate}}</p>
                            <input type="text" name="email" formControlName="email" maxlength="100" placeholder="{{'Enter your email' | translate}}">
                            <p class="note-small-text text-danger">* {{'Please enter valid email address. The OTP will be sent to this email.' | translate}}</p>
                        </div>

                        <div *ngIf="isSubmittedEmployee && gEmployee.email.errors" class="invalid-feedback">
                            <div *ngIf="gEmployee.email.errors?.required">{{'This field is mandatory'|translate}}</div>
                            <div *ngIf="gEmployee.email.errors?.pattern">{{'This field should be valid'|translate}}</div>
                        </div>
                    </div>

                    <div class="nif-btn-submit-div text-center">
                        <button class="btn btn-medium" (click)="onSubmitVerifyEmployee()">{{'Next'|translate}}</button>
                    </div>
                </form>
            </div>
        </div>

        <div class="verify-inner-box-div modal-lg text-input-left" *ngIf="isEmployeeDetailSection">

            <div class="employee-detail-section" >
                <div class="display-flex-head-mobile">
                    <button class="back-btn-verify position-unset-mobile" (click)="onBack('employee-detail')"><img src="assets/images/back-arrow.png" alt=""></button>
                    <h2 class="verify-title text-center">{{'Employee details' | translate}}</h2>
                </div>

                <form >
                    <div class="sub-section-with-line mb-3">
                        <!-- <div class="container mt-5">
                        <h6 class="">{{'Employee details' | translate}}<span class="mandatory" >*</span></h6>
                        </div> -->
                        <div class="line mt-3"></div>
                    </div>

                    <div class="form-grid-group">
                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'First name' | translate}}</p>
                                <input type="text" name="first_name" value="{{NIFResponseOtp?.first_name || '--'}}" readonly>
                            </div>
                        </div>

                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Last name' | translate}}</p>
                                <input type="text" name="last_name" value="{{NIFResponseOtp?.last_name || '--'}}" readonly>
                            </div>
                        </div>

                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Email' | translate}}</p>
                                <input type="text" name="email" value="{{NIFResponseOtp?.email || '--'}}" readonly>
                            </div>
                        </div>

                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Birthdate' | translate}}</p>
                                <input type="text" name="birthdate" value="{{NIFResponseOtp?.birthdate || '--'}}" readonly>
                            </div>
                        </div>

                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Birthplace' | translate}}</p>
                                <input type="text" name="birthplace" value="{{NIFResponseOtp?.birthplace || '--'}}" readonly>
                            </div>
                        </div>

                        <div class="input-div">
                            <div class="input-box-white">
                                <p class="labeltxt ">{{'Phone number' | translate}}</p>
                                <input type="text" name="phone_number" value="{{NIFResponseOtp?.phone_number || '--'}}" readonly>
                            </div>
                        </div>

                    </div>
                    <div class="form-check verify-employee-checkbox text-center mt-3">
                        <input
                        class="form-check-input"
                        type="checkbox"
                        id="flexCheckDefault"
                        name="employeeConfirm"
                        [(ngModel)]="isEmployeeConfirm">
                        <label class="form-check-label" for="flexCheckDefault">
                        {{'I confirm that the information provided is correct and I accept the'| translate}} 
                        <!-- <a href="#">{{'Terms and conditions'| translate}}</a> -->
                        <span class="tandc-link">{{'Terms and conditions'| translate}}</span>
                        </label>
                    </div>
                    <div *ngIf="isSubmittedEmployeeDetail && !isEmployeeConfirm" class="invalid-feedback d-block text-center">
                        {{'You must accept the terms and conditions before submitting.' | translate}}
                    </div>
                    <div class="nif-btn-submit-div text-center mt-1">
                        <button class="btn btn-medium" (click)="onSubmitVerifyEmployeeDetail()">{{'Submit'|translate}}</button>
                    </div>
                </form>


            </div>
        </div>

        

    </div>
</div>

<app-footer></app-footer>
<app-contact-floating></app-contact-floating>

<section class="modal-section">






<div class="modal fade-scale" id="companyNotFoundModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
            <div class="verify-nif-modal-content text-center">
                <img [src]="isSuccessModal ? 'assets/images/valid.png' : 'assets/images/resub.png'" alt="" class="not-found-img mb-3">
                <h2 class="modal-title mb-2" *ngIf="modalHeading">{{modalHeading | translate}}</h2>

                <p class="modal-description text-center" *ngIf="modalDescription">{{modalDescription | translate}}</p>
                <div class="btn-yes-no">
                    <button class="yes-btn" data-dismiss="modal" (click)="statusModal(modalStatus)">{{'Close' | translate}}</button>
                    
                </div>
            </div>
         
        </div>
      </div>
    </div>
</div>

<div class="modal fade-scale" id="otpVerifyModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate"   aria-label="Close" (click)="closeOTPVerifyModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="modal-image-container">
            <!-- <h5 class="modal-title title-medium" id="exampleModalLongTitle">
              <div class="logo-div">
              <img src="assets/images/inner-logo.svg" alt="">
            </div>
          </h5> -->

          </div>
         
        <div class="text-container">
            <div class="otp-section" *ngIf="isOTPSection"> 
                <h5 class="title-medium">{{'Email verification' | translate}}</h5>
                <p>{{'Enter your OTP for email verification' | translate}}</p>
                <form class="form-container" [formGroup]="otpFormSignIn" >
                  <div class="otp-container">
                    <div class="otp-input otpVerifyOtp">
                      <input type="tel" formControlName="otp1" #otpInputs maxlength="1" minlength="1" class="input" />
                      <input type="tel" formControlName="otp2" #otpInputs maxlength="1" minlength="1" class="input" />
                      <input type="tel" formControlName="otp3" #otpInputs maxlength="1" minlength="1" class="input" />
                      <input type="tel" formControlName="otp4" #otpInputs maxlength="1" minlength="1" class="input" />
                    </div>
                    <div *ngIf="isSubmittedOTP">
                      <div *ngIf="i.otp1.errors?.required || i.otp2.errors?.required || i.otp3.errors?.required || i.otp4.errors?.required" class="invalid-feedback">{{'OTP'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="(i.otp1.value || i.otp2.value || i.otp3.value || i.otp4.value) && (i.otp1.errors?.pattern || i.otp2.errors?.pattern || i.otp3.errors?.pattern || i.otp4.errors?.pattern)" class="invalid-feedback">{{'OTP'|translate}} {{'is not valid'|translate}}</div>
                    </div>
                  </div>
                  <p id="timer" *ngIf="!isResendEnabled">{{ timerSeconds }} {{'Seconds remaining' | translate}}</p>
                  <p id="resend-otp" 
                     *ngIf="isResendEnabled"
                     [style.cursor]="'pointer'"
                     (click)="onResendOTP()">
                    {{'Resend OTP' | translate}}
                  </p>
                  <button type="submit" id="submit_btn" class="btn btn-main" (click)="onOTPVerify()">{{'Next' | translate}}</button>
                </form>
            </div>

            <div class="employee-yes-verify-section text-center" *ngIf="isEmployeeYesVerifySection">
                <h2 class="modal-title-verify" *ngIf="!isEmployee">{{'Are you' | translate}} <span>{{NIFResponseOtp?.company_name || '--'}}</span> ?</h2>
                <h2 class="modal-title-verify" *ngIf="isEmployee">{{'Are you' | translate}} <span>{{NIFResponseOtp?.first_name || '--'}} {{NIFResponseOtp?.last_name || '--'}}</span> ?</h2>

                <p class="modal-description text-center mb-5" *ngIf="!isEmployee && !legalNatureStatus">{{'Please review the company name displayed above and confirm that it matches the official registered name of your organization.'| translate}} </p>
                <p class="modal-description text-center mb-5" *ngIf="!isEmployee && legalNatureStatus">{{'Please review the name displayed above. Since your company is an individual company, the displayed name is the manager/owner name (from DGI).'| translate}} </p>

                <div class="btn-yes-no">
                    <button class="yes-btn" (click)="onYesVerifyNIF(true)">{{'Yes' | translate}}</button>
                    <button class="no-btn" (click)="onYesVerifyNIF(false)">{{'No' | translate}}</button>
                </div>

            </div>

            
       
        </div>
       
    
    
    
        </div>
      </div>
    </div>
  </div>


  <!-- <div class="modal fade-scale" id="otpVerifyModalEmployee" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate"  data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="modal-image-container">
            <h5 class="modal-title title-medium" id="exampleModalLongTitle">
              <div class="logo-div">
              <img src="assets/images/pups-logo-header.png" alt="">
            </div>
          </h5>

          </div>
         
        <div class="text-container">

            <div class="otp-section" *ngIf="isOTPSection"> 
                <h5 class="title-medium">{{'Email verification' | translate}}</h5>
                <p>{{'Enter your OTP for email verification' | translate}}</p>
                <form class="form-container" [formGroup]="otpFormSignIn" >
                  <div class="otp-container">
                    <div class="otp-input otpVerifyOtp">
                      <input type="tel" formControlName="otp1" #otpInputs maxlength="1" minlength="1" class="input" />
                      <input type="tel" formControlName="otp2" #otpInputs maxlength="1" minlength="1" class="input" />
                      <input type="tel" formControlName="otp3" #otpInputs maxlength="1" minlength="1" class="input" />
                      <input type="tel" formControlName="otp4" #otpInputs maxlength="1" minlength="1" class="input" />
                    </div>
                   
                  </div>
                  <p id="timer" *ngIf="!isResendEnabled">{{ timerSeconds }} {{'Seconds remaining' | translate}}</p>
                  <p id="resend-otp" 
                     *ngIf="isResendEnabled"
                     [style.cursor]="'pointer'"
                     (click)="onResendOTP()">
                    {{'Resend OTP' | translate}}
                  </p>
                  <button type="submit" id="submit_btn" class="btn btn-main" (click)="onOTPVerify()">{{'Verify' | translate}}</button>
                </form>
            </div>
        
            <div class="employee-yes-verify-section text-center" >
                <h2 class="modal-title-verify">{{'Are you' | translate}} <span>{{NIFResponse?.business_name || 'John Honay'}}</span> ?</h2>

                <p class="modal-description text-center mb-5">{{'Please confirm that the information provided is correct'| translate}} </p>

                <div class="btn-yes-no">
                    <button class="yes-btn" (click)="onYesVerifyEmployee()">{{'Yes' | translate}}</button>
                    <button class="no-btn" (click)="onYesVerifyEmployee()">{{'No' | translate}}</button>
                </div>

            </div>

            
       
        </div>
       
    
    
    
        </div>
      </div>
    </div>
  </div> -->
</section>